<template>
    <div>
        <a-spin :spinning="isloading" tip="加载中...">
            <div class>
                <div class="mainWrapper clearfix">
                    <div>
                        <div class="pxkeji-right-box" style="margin-top:0">
                            <a-table
                                    :columns="list.columns"
                                    :dataSource="list.datas"
                                    :loading="isloading"
                                    :rowSelection="{type:'checkbox',onChange:onRowChange,selectedRowKeys:selectRows}"
                                    :locale="{emptyText:'暂无数据'}"
                            >
                                <template
                                        v-for="col in ['buyPrice']"
                                        :slot="col"
                                        slot-scope="text, record, index"
                                >
                                    <div :key="col">
                                        <a-input
                                                v-if="record.editable"
                                                style="margin: -5px 0"
                                                :value="text"
                                                @change="e => handleChange(e.target.value, record.key, col)"
                                        />
                                        <template v-else>
                                            {{ text }}
                                        </template>
                                    </div>
                                </template>
                                <template slot="operation" slot-scope="text, record, index">
                                    <div class="editable-row-operations">
        <span v-if="record.editable">
          <a @click="() => save(record.key)">保存</a>
          <a-popconfirm title="你确定要取消吗?" @confirm="() => cancel(record.key)">
            <a>取消</a>
          </a-popconfirm>
        </span>
                                        <span v-else>
          <a :disabled="editingKey !== ''" @click="() => edit(record.key)">修改</a>
        </span>
                                    </div>
                                </template>
                            </a-table>
                            <a-button type="primary" :style="{ margin:'10px'}" @click="refund">退款</a-button>
                        </div>
                    </div>
                </div>

            </div>
        </a-spin>
    </div>
</template>

<script>
    var that;
    const columns = [
        {
            dataIndex: "productName",
            key: "productName",
            align: "center",
            title: "商品名称",
            scopedSlots: {customRender: 'productName'},
        },
        {
            dataIndex: "buyPrice",
            key: "buyPrice",
            align: "center",
            title: "退款金额",
            scopedSlots: {customRender: 'buyPrice'},
        },
        // {
        //     title: '操作',
        //     dataIndex: 'operation',
        //     scopedSlots: {customRender: 'operation'},
        // },
    ];
    export default {
        props: {
            id: String
        },
        data() {

            return {
                data: [],
                cacheData: [],
                columns,
                editingKey: '',
                classList: [],
                replaceFields: {children: "children", title: "name", key: "id"},
                list: {
                    columns, //表头
                    datas: [], //数据
                    pagination: {
                        //分页器
                        showQuickJumper: true,
                        hideOnSinglePage: true,
                        total: 0,
                        current: 1, //页码
                        defaultPageSize: 10 //页容
                    }
                },
                where: {
                    //查询条件
                    keyword: {
                        //搜索条件
                        courseName: "",
                        typeId: null,
                    }
                },
                allSelectRows: [],
                selectRows: [], //选中项编号
                isloading: false,
            };
        },
        mounted() {
            this.$nextTick(() => {
                that = this;
                // this.allSelectRows = this.ids ? this.ids : [];
                this.GetList();
            });
        },
        methods: {
            handleChange(value, key, column) {
                const newData = [...this.list.datas];
                const target = newData.filter(item => key === item.key)[0];
                if (target) {
                    target[column] = value;
                    this.list.datas = newData;

                }
            },
            edit(key) {
                const newData = [...this.list.datas];
                const target = newData.filter(item => key === item.key)[0];
                this.editingKey = key;
                if (target) {
                    target.editable = true;
                    this.list.datas = newData;
                }

            },
            save(key) {
                const newData = [...this.list.datas];
                const newCacheData = [...this.cacheData];
                const target = newData.filter(item => key === item.key)[0];
                const targetCache = newCacheData.filter(item => key === item.key)[0];
                if (target && targetCache) {
                    delete target.editable;
                    this.list.datas = newData;
                    // this.onRowChange(key);
                    Object.assign(targetCache, target);
                    this.cacheData = newCacheData;
                }
                this.editingKey = '';
            },
            cancel(key) {
                const newData = [...this.list.datas];
                const target = newData.filter(item => key === item.key)[0];
                this.editingKey = '';
                if (target) {
                    Object.assign(target, this.cacheData.filter(item => key === item.key)[0]);
                    delete target.editable;
                    this.list.datas = newData;
                }
            },

            GetList() {
                this.isloading = true;
                this.$api.order
                    .orderItemDetails(
                        this.id
                    )
                    .then(res => {
                        this.isloading = false;
                        if (res.errorCode == this.$msg.responseCode.success) {
                            // this.list.datas = res.data;
                            for (let i = 0; i < res.data.length; i++) {
                                this.list.datas.push({
                                    key: i.toString(),
                                    id: res.data[i].id,
                                    productName: res.data[i].productName,
                                    buyPrice: res.data[i].buyPrice,
                                    productId: res.data[i].productId,
                                });
                            }
                            this.cacheData = this.list.datas.map(item => ({...item}));


                        } else {
                            this.$message.error(res.errorMsg);
                        }
                    })
                    .catch(() => {
                        this.isloading = false;
                    });
            },
            //选择并返回
            refund() {
                var data = [];
                if (this.allSelectRows.length == 0) {
                    this.$message.error("请选择课程");
                    return
                }
                var rows = this.allSelectRows.join(",");

                for (let i = 0; i < this.list.datas.length; i++) {
                    if (rows.indexOf(this.list.datas[i].id != -1)) {
                        data.push(this.list.datas[i]);
                    }
                }
                this.isloading = true;
                this.$api.order
                    .refundOrderItem(
                        this.id,
                        JSON.stringify(this.list.datas),
                    )
                    .then(res => {
                        this.isloading = false;
                        if (res.errorCode == this.$msg.responseCode.success) {
                            // this.$emit("callbackMethod");

                        } else {
                            this.$message.error(res.errorMsg);
                        }
                    })
                    .catch(() => {
                        this.isloading = false;
                    });
            },
            onRowChange(selectedRowKeys) {
                this.selectRows = selectedRowKeys;
                for (var i in that.list.datas) {

                    if (selectedRowKeys.indexOf(that.list.datas[i].key) != -1) {
                        //选中
                        var find = false;
                        for (var sel in that.allSelectRows) {
                            if (that.allSelectRows[sel] == that.list.datas[i].id) {
                                find = true;
                                break;
                            }
                        }
                        if (!find) {
                            that.allSelectRows.push(that.list.datas[i].id);
                        }

                    } else {
                        for (var sel in that.allSelectRows) {
                            if (that.allSelectRows[sel] == that.list.datas[i].id) {
                                that.allSelectRows.splice(sel, 1);
                                break;
                            }
                        }
                    }
                }
            },
        }
    };
</script>
<style>
    .mainWrapper {
        box-sizing: border-box !important;
    }

    .articleMeauleft {
        width: 20%;
        padding: 0 1%;
        min-height: 700px;
        background: #fff;
        float: left;
        margin-top: 24px;
    }


    .courseClass {
        padding-left: 10px;
    }

    .courseClass span {
        font-size: 14px;
        line-height: 2.5;
        cursor: pointer;
    }
</style>